/*
 * @Description:自有车账目
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-01-04 15:47:56
 * @LastEditors: WangYuhan
 */
import { getDriverList, getVehicleList } from '@/api/capacity';
import { getRouteListByBid, getProjectListByBid } from '@/api/common';
import { ownPageList } from '@/api/waybill';

const storeModelName = 'ownerAccountsModule';

const state = {
  parameters: [
    {
      style: 'select',
      value: '',
      state: 'corps',
      label: '企业',
      isFixed: true,
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: true,
      filterable: false,
      param: 'businessId',
    },
    {
      style: 'select',
      value: '',
      state: 'projects',
      label: '项目名称',
      placeholder: '请选择',
      noMatchText: '无匹配项目',
      clearable: true,
      filterable: true,
      param: 'projectId',
      path: `${storeModelName}/getProject`,
    },
    {
      style: 'select',
      value: '',
      state: 'routeInfoList',
      label: '线路名称',
      placeholder: '请选择',
      noMatchText: '无匹配线路',
      clearable: true,
      filterable: true,
      param: 'routeInfoId',
      path: `${storeModelName}/getRouteInfoList`,
    },
    {
      style: 'input',
      value: '',
      label: '运单编号',
      placeholder: '请输入',
      clearable: true,
      param: 'waybillNo',
    },
    {
      style: 'select',
      value: '',
      state: 'drivers',
      label: '司机',
      placeholder: '请选择',
      noMatchText: '无匹配司机',
      clearable: true,
      filterable: true,
      param: 'driverInfoId',
      path: `${storeModelName}/getDrivers`,
    },
    {
      style: 'select',
      value: '',
      state: 'vehicles',
      label: '车辆',
      placeholder: '请选择',
      noMatchText: '无匹配车辆',
      clearable: true,
      filterable: true,
      param: 'vehicleInfoId',
      path: `${storeModelName}/getVehicles`,
    },
    {
      style: 'date-picker',
      value: [],
      label: '建单时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'createTime',
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'casccader',
      value: [],
      label: '装货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['sendProvince', 'sendCity', 'sendDistrict'],
    },
    {
      style: 'casccader',
      value: [],
      label: '卸货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['receiveProvince', 'receiveCity', 'receiveDistrict'],
    },
  ],
  postParams: {
    size: 20,
    page: 1,
  },

  corps: [],
  projects: [],
  routeInfoList: [],
  drivers: [],
  vehicles: [],
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单信息',
        prop: 'waybill',
        checked: 1,
        width: 170,
        sortable: true,
        slotName: 'sub-domain-waybill',
      },
      {
        label: '运力信息',
        prop: 'capacity',
        checked: 1,
        width: 120,
        sortable: true,
        slotName: 'sub-domain-capacity',
      },
      {
        label: '历史运输成本（元）',
        prop: 'historyEtcCost',
        checked: 1,
        width: 140,
        sortable: true,
        slotName: 'sub-domain-historyEtcCost',
      },

      {
        label: '运输成本(元)',
        prop: 'ownTransportationCost',
        checked: 1,
        width: 160,
        sortable: true,
        slotName: 'sub-domain-ownTransportationCost',
        tips: [
          '总成本=ETC+油费',
          'ETC：如果没有选择路线方案，默认为空可编辑；如果有路线方案默认取路线方案预估ETC费用，在运单卸货后24h后如果有实际的ETC发卡方的费用，系统更新一次',
          '分油金额：创建运单分油的金额',
          '加油金额：在途加油金额的合计',
          '平均油价：运单加油的平均油价，多次加油取平均值',
        ],
      },
      {
        label: '降本金额(元)',
        tips: ['ETC对比：相同车型和相同高速出入口的对比', 'ETC=历史ETC金额-运输成本ETC金额'],
        prop: 'ownCostReduction',
        checked: 1,
        width: 140,
        sortable: true,
        slotName: 'sub-domain-ownCostReduction',
      },
      {
        label: '历史百公里成本(元/100km)',
        prop: 'historyHundredOilCost',
        checked: 1,
        width: 180,
        sortable: true,
        slotName: 'sub-domain-historyHundredOilCost',
      },
      {
        label: '百公里成本(元/100km)',
        prop: 'ownInputCost',
        checked: 1,
        width: 180,
        sortable: true,
        slotName: 'sub-domain-ownInputCost',
      },
      {
        label: '百公里降本金额（元）',
        prop: 'hundredReductionOil',
        checked: 1,
        width: 180,
        sortable: true,
        slotName: 'sub-domain-hundredReductionOil',
      },
      {
        label: '行业标准 ',
        prop: '',
        checked: 1,
        width: 80,
        sortable: true,
      },
      {
        label: '降本策略',
        prop: 'strategyReductionIol',
        checked: 1,
        width: 180,
        sortable: true,
        tips: [
          '预估ETC降本=实际ETC费用-路线方案中最低ETC费用（符合以下条件 1.路线没有选择路线方案但是实际有、2.实际ETC费用不为空）',
        ],
        slotName: 'sub-domain-strategyReductionIol',
      },
      {
        label: '建单时间',
        prop: 'createTime',
        checked: 1,
        width: 150,
        sortable: true,
      },
    ],
    total: 0,
  },
};

const getters = {};

const actions = {
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.style !== 'casccader' && item.value) {
        if (item.multiple) {
          if (item.value.length > 0) {
            params[item.param] = item.value.toString();
          }
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
      if (item.style === 'casccader' && item.value.length > 0) {
        params[item.params[0]] = item.value[0] ? `${item.value[0]}` : '';
        params[item.params[1]] = item.value[1] ? `${item.value[1]}` : '';
        params[item.params[2]] = item.value[2] ? `${item.value[2]}` : '';
      }
    });
    const { code, data } = await ownPageList(
      Object.assign(
        {},
        {
          page: context.state.postParams.page,
          size: context.state.postParams.size,
        },
        params,
      ),
    );
    if (code === 200) {
      context.commit('updateListData', data);
    }
  },

  getProject: async (context, keyword) => {
    const { code, data } = await getProjectListByBid({
      businessId: context.state.parameters[0].value,
      keyword,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.name;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'projects',
        value: data.list,
      });
    }
  },
  getRouteInfoList: async (context, keyword) => {
    const { code, data } = await getRouteListByBid({
      businessId: context.state.parameters[0].value,
      projectId: context.state.parameters[1].value,
      lineType: 'own',
      keyword,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.orderName;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'routeInfoList',
        value: data.list,
      });
    }
  },
  getDrivers: async (context, name) => {
    const { code, data } = await getDriverList({
      driverProperty: 'own',
      name,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.name;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'drivers',
        value: data.list,
      });
    }
  },
  getVehicles: async (context, vehicleNo) => {
    const { code, data } = await getVehicleList({
      vehicleProperty: 'own',
      vehicleNo,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.vehicleNo;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'vehicles',
        value: data.list,
      });
    }
  },
};

const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = Object.assign({}, state.listData, payload);
  },
  updateState(state, payload) {
    state[payload.key] = payload.value;
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    if (payload.index === 0) {
      state.projects = [];
      state.routeInfoList = [];
    }
  },
  // 重置所有状态
  initFilter(state) {
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker' || item.style === 'casccader') {
        item.value = [];
      }
      if (item.state && item.state !== 'corps') {
        state[item.state] = [];
      }
    });
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.projects = [];
    state.routeInfoList = [];
    state.drivers = [];
    state.vehicles = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
